<template>
  <div class="vx-row">
    <div class="w-full vx-col">
      <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="mb-8 user-list-filters"
        :collapse-action="true">
        <div class="vx-row">
          <div class="w-full vx-col md:w-1/3 sm:w-1/2">
            <label class="text-sm opacity-100 text-bold">Name</label>
            <vs-input type="search" placeholder="Search.." v-model="filters['name']" class="w-full mb-4 md:mb-0" />
          </div>
        </div>
        <div class="mt-5 vx-row">
          <div class="w-full ml-auto vx-col">
            <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
              v-on:click="filters = {}">CLEAR</vs-button>
          </div>
        </div>
      </vx-card>
      <vx-card :title="'CRM SNAPSHOT VAM TYPES'" class="">
        <template slot="actions">
          <vs-button v-can="'edit-snapshot-vam-types-setting'" @click.stop="onClickAdd" icon-pack="feather"
            icon="icon-plus" class="mr-4" color="primary" type="filled">create</vs-button>
        </template>
        <div id="subjets-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe class="mt-8" :data="crm_subjects">
              <template slot="thead">
                <vs-th width="5%"></vs-th>
                <vs-th width="15%">Order</vs-th>
                <vs-th width="60%">Name</vs-th>
                <vs-th width="20%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <draggable
                  v-model="crm_subjects"
                  tag="tbody"
                  handle=".drag-handle"
                  animation="200"
                  @end="onDragEnd"
                >
                  <vs-tr class="cursor-pointer" :key="item.id || index" v-for="(item, index) in crm_subjects">
                    <vs-td>
                      <i class="feather icon-menu drag-handle cursor-move"></i>
                    </vs-td>

                    <vs-td :data="item.order">
                      {{ item.order !== null && item.order !== undefined ? item.order : index + 1 }}
                    </vs-td>

                    <vs-td :data="item.name">
                      {{ item.name }}
                    </vs-td>

                    <vs-td :data="item.id">
                      <div class="justify-start vx-row" v-can="'edit-snapshot-vam-types-setting'">
                        <vx-tooltip text="View/Update" position="left">
                          <vs-button @click.stop="onClickUpdate(item.id)" class="ml-3" size="small" color="warning"
                            type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip text="Remove" position="left">
                          <vs-button @click.stop="openConfirm(item.id)" class="ml-3" size="small" color="danger"
                            type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                        </vx-tooltip>
                      </div>
                    </vs-td>
                  </vs-tr>
                </draggable>
              </template>

            </vs-table>

          </div>
        </div>
      </vx-card>
    </div>
    <add-new-crm-vam-type-pop-up ref="addNewCrmVamTypePopUp" />
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { RepositoryFactory } from '@/repository/RepositoryFactory';

import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

import { defaultPagination, perPageList } from "@/constants/config";
import AddNewCrmVamTypePopUp from '@/components/popups/settings/crm-vam-type/AddNewCrmVamTypePopUp.vue';

const CrmRepository = RepositoryFactory.get('crm');
export default {
  name: "CustomerCrmSubjectSettings",
  data() {
    return {
      crm_subjects: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
    }
  },
  components: {
    draggable,
    AddNewCrmVamTypePopUp
  },
  methods: {
    async refreshData() {
      await this.fetchCrmSubjects()
    },
    async fetchCrmSubjects() {
      await this.$vs.loading({
        container: '#subjets-table',
        scale: 0.45
      })
      const { data } = (await CrmRepository.getListVamType()).data
      this.crm_subjects = data
      this.$vs.loading.close('#subjets-table > .con-vs-loading')
    },
    async onDragEnd() {
      await this.$vs.loading({
        container: '#subjets-table',
        scale: 0.45
      })
      try {
        this.crm_subjects = this.crm_subjects.map((item, index) => ({
          ...item,
          order: index + 1
        }));
        const payload = {
          types: this.crm_subjects.map((item) => ({
            id: item.id,
            order: item.order
          }))
        };
        await CrmRepository.reorderCrmVamTypes(payload);
        this.showSuccessMessage('Order updated successfully!');
      } catch (e) {
        this.convertAndNotifyError(e);
        await this.fetchCrmSubjects();
      } finally {
        this.$vs.loading.close('#subjets-table > .con-vs-loading');
      }
    },
    async onClickAdd() {
      const nextOrder = (this.crm_subjects && this.crm_subjects.length ? this.crm_subjects.length : 0) + 1;
      await this.$refs.addNewCrmVamTypePopUp.openPopup(null, nextOrder)
    },
    async onClickUpdate(id) {
      await this.$refs.addNewCrmVamTypePopUp.openPopup(id)
    },
    openConfirm(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure you want to delete this ?',
        accept: this.onClickDelete,
        parameters: [id]
      })
    },
    async onClickDelete(params) {
      try {
        await CrmRepository.deleteCrmVamType(params[0])
        await this.fetchCrmSubjects()
        await this.showSuccessMessage('Subject Deleted!');
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    filterQueryUpdate() {
      this.fetchCrmSubjects()
    },

    handleChangePage(page) {
      this.page = page;
      this.fetchCrmSubjects()
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchCrmSubjects()
      }
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
  },
  async mounted() {
    await this.fetchCrmSubjects()
  },
  mixins: [Filter, SuccessMessage, ErrorMessages],
  watch: {
    page() {
      this.fetchCrmSubjects()
    },
    perPage() {
      this.fetchCrmSubjects()
    }
  }
}
</script>

<style scoped>
.drag-handle {
  cursor: grab;
  font-size: 16px;
}
.cursor-move {
  cursor: move;
}
</style>
